const DEMO_COPY = {
  en: {
    bannerAria: "Demo environment",
    interactive: "Pilcore demo",
    readOnly: "Hotel data · Read-only",
    preparing: "Preparing Hotel Travesia...",
    loadError: "We could not load the hotel demo. Please try again.",
    retry: "Try again",
    snapshotDate: "Hotel data as of",
    desktopTitle: "Open the demo on a desktop computer",
    desktopBody:
      "The interactive Pilcore experience is currently designed for desktop screens. Open this same link on a computer to try it.",
    desktopFooter: "The demo is available in read-only mode.",
  },
  es: {
    bannerAria: "Entorno de demostración",
    interactive: "Demo de Pilcore",
    readOnly: "Datos del hotel · Solo consulta",
    preparing: "Preparando Hotel Travesía...",
    loadError: "No hemos podido cargar la demo del hotel. Vuelve a intentarlo.",
    retry: "Reintentar",
    snapshotDate: "Datos del hotel a fecha de",
    desktopTitle: "Abre la demo desde un ordenador",
    desktopBody:
      "La experiencia interactiva de Pilcore está preparada de momento para pantallas de escritorio. Abre este mismo enlace desde un ordenador para probarla.",
    desktopFooter: "La demo está disponible en modo solo consulta.",
  },
  ca: {
    bannerAria: "Entorn de demostració",
    interactive: "Demo de Pilcore",
    readOnly: "Dades de l'hotel · Només consulta",
    preparing: "Preparant Hotel Travesía...",
    loadError: "No hem pogut carregar la demo de l'hotel. Torna-ho a provar.",
    retry: "Torna-ho a provar",
    snapshotDate: "Dades de l'hotel a data de",
    desktopTitle: "Obre la demo des d'un ordinador",
    desktopBody:
      "L'experiència interactiva de Pilcore està preparada de moment per a pantalles d'escriptori. Obre aquest mateix enllaç des d'un ordinador per provar-la.",
    desktopFooter: "La demo està disponible en mode només consulta.",
  },
};

export function getDemoCopy(languageId) {
  return DEMO_COPY[languageId] || DEMO_COPY.es;
}
